var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDamages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81.94,
    height: 74.73,
    viewBox: "0 0 84 74.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8310",
    "data-name": "Group 8310",
    transform: "translate(16495 20866.408)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "broken-shield-svgrepo-com",
    d: "M45.906,23.625v1.492c0,16.4,2.072,32.755,8.121,46.022S70.292,94.683,86.364,98.255l.438.1.438-.08a54.753,54.753,0,0,0,6.876-1.659c13.246-3.987,21.8-13.361,26.769-25.1,5.673-13.4,6.961-29.99,6.961-46.4V23.625Zm3.715,2.985h74.516c-.082,15.78-1.48,31.518-6.739,43.941-5.373,12.7-14.493,21.823-30.485,24.72C72.442,91.912,63.233,82.7,57.489,70.106c-5.623-12.332-7.742-27.811-7.868-43.5ZM53.336,29.6C53.5,43.041,55.8,57.206,61.1,68.7a54.038,54.038,0,0,0,5.381,9.273l9.053-6.139L67.487,59.85l-1.08-1.607,2.166-.534s7.675-1.882,11.929-2.915l4.036-1.158L65.808,29.6Zm31.645,0,9.041,14.614,26.147-6.893c.136-2.588.208-5.169.228-7.721H84.981Zm34.984,10.915-24.271,6.4,4.919,7.95,5.11,7.781,10.522-.295a105.119,105.119,0,0,0,3.721-21.836Zm-21.728,17.1-6.072,1.657,13.28,23.188A43.8,43.8,0,0,0,113.863,69.1q.764-1.82,1.42-3.728l-10.59.295-1.154.035L103,64.876Zm-19.594.748c-2.593.634-5.4,1.32-6.838,1.672L79.5,71.483l.716,1.073-1.154.784L68.48,80.512A34.571,34.571,0,0,0,87.173,92.191a33.02,33.02,0,0,0,15.014-6.718L78.644,58.367Z",
    transform: "translate(-16540.906 -20890.033)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDamages);
export default __webpack_public_path__ + "static/media/damages.c2274dbe6b79915464e1580ad36350de.svg";
export { ForwardRef as ReactComponent };